export default {"src":"/_next/static/media/icon-check.88287189.svg","height":24,"width":24};